module.exports = __webpack_public_path__ + "static/media/portfolio (16).b4b4d229.jpg";